import { defineStore } from "pinia";
import { ref, computed } from "vue";
import * as RequestService from "@/services/RequestService";

export const useRequestsStore = defineStore("requests", () => {
  const inProgressRequests = ref([]);
  const openRequests = ref([]);
  const closedRequests = ref([]);
  const requestDetails = ref({});
  const inProgressLoaded = ref(false);
  const openLoaded = ref(false);
  const suggestedRequests = ref([]);

  const inProgressAndOpenRequests = computed(() => {
    return [...inProgressRequests.value, ...openRequests.value].sort(
      (a, b) => new Date(a.issued_at) - new Date(b.issued_at),
    );
  });

  async function refreshOpenRequests() {
    openRequests.value = await RequestService.openRequests();
    openLoaded.value = true;
  }

  async function refreshInProgressRequests() {
    inProgressRequests.value = await RequestService.inProgressRequests();
    inProgressLoaded.value = true;
  }

  async function refreshClosedRequests() {
    closedRequests.value = await RequestService.closedRequests();
  }

  function refreshAllRequests() {
    refreshOpenRequests();
    refreshInProgressRequests();
    refreshClosedRequests();
  }

  async function fetchRequest(requestId) {
    const requestData = await RequestService.getRequest(requestId);
    if (requestData.details) {
      requestData.messages.push({
        id: -1,
        body_html: `<p>We've received your request and your LifeConcierge will be in contact soon!</p><p>Here are the details of your request:</p><p>${requestData.details}</p>`,
        source_name: "Overalls",
        source: "life_concierge",
        external_created_at: requestData.created_at,
      });
    }
    requestData.messages.sort(
      (a, b) => new Date(a.external_created_at) - new Date(b.external_created_at),
    );

    requestDetails.value[requestId] = requestData;
  }

  async function fetchSuggestedRequests() {
    suggestedRequests.value = await RequestService.suggestedRequests();
  }

  return {
    inProgressRequests,
    openRequests,
    closedRequests,
    inProgressLoaded,
    openLoaded,
    inProgressAndOpenRequests,
    requestDetails,
    suggestedRequests,
    refreshAllRequests,
    refreshOpenRequests,
    refreshInProgressRequests,
    refreshClosedRequests,
    fetchRequest,
    fetchSuggestedRequests,
  };
});
